import React from "react";

import { Autocomplete, Box, FormControl, TextField } from "@mui/material";

import { Source } from "Constant/source";

import { getZohoAuthUrl } from "helpers/Sources/createSource";

import CrmSourceMappingArea from "components/CrmSourceMappingArea";
import LoginButton from "components/molecules/LoginButton";

const ZohoSourceForm = ({ language, zoho, registerFooterAction }) => {
    const {
        modules,
        selectedModule,
        name,
        isModuleSelectDisabled,
        hasFields,
        sourceId,
        isLoading,
        handleModuleChange,
        handleNameChange,
        handleLoginSuccess,
        handleMappingSuccess,
    } = zoho;

    if (hasFields) {
        return (
            <CrmSourceMappingArea
                sourceId={sourceId}
                sourceType={Source.zoho}
                mappingSuccess={handleMappingSuccess}
                isSaveButtonLoading={isLoading}
                hideSaveButton
                registerFooterAction={registerFooterAction}
            />
        );
    }

    const moduleLabel =
        language?.source_modal?.choose_a_module ?? "Choose a module";

    return (
        <Box>
            <FormControl fullWidth sx={{ mb: 3 }}>
                <TextField
                    name="name"
                    label={language?.trackers_page?.name ?? "Name"}
                    variant="outlined"
                    onChange={handleNameChange}
                    value={name}
                    placeholder={
                        language?.source_modal?.please_write_name ??
                        "Please write name"
                    }
                />
            </FormControl>
            <FormControl fullWidth sx={{ mb: 3 }}>
                <Autocomplete
                    onChange={handleModuleChange}
                    value={selectedModule || null}
                    disabled={isModuleSelectDisabled}
                    options={modules ?? []}
                    getOptionLabel={(option) => option}
                    freeSolo
                    renderInput={(params) => (
                        <TextField {...params} label={moduleLabel} />
                    )}
                />
            </FormControl>
            <Box sx={{ position: "relative", overflow: "hidden", zIndex: 1 }}>
                <LoginButton
                    code="zoho"
                    isLoadingExternal={isLoading}
                    getAuthUrl={getZohoAuthUrl}
                    getAuthUrlData={selectedModule}
                    getAuthUrlResponseTransform={(response) =>
                        response?.data?.url
                    }
                    paramNames={["code", "location", "accounts-server"]}
                    onSuccess={handleLoginSuccess}
                    dataTransform={(params) => ({
                        code: params.code,
                        location: params.location,
                        account_server: params["accounts-server"],
                        name: name ?? "",
                        source_type: Source.zoho,
                        module: selectedModule ?? "",
                    })}
                    logoSrc="/assets/images/zohoLogo.png"
                    logoWidth={60}
                    buttonText="Zoho Login"
                    disabled={
                        !selectedModule || !name?.trim() || !modules?.length
                    }
                />
            </Box>
        </Box>
    );
};

export default ZohoSourceForm;
